/* FW-JUDGEME-REVIEWS v4 (2026-07-05)
 * Buy-box star badge, self-rendered.
 *
 * v3 relied on Judge.me hydrating a client-injected .jdgm-preview-badge div.
 * Judge.me only server-renders badges via liquid; its bundle merely tracks
 * impressions on client-injected divs and never fills them, so the badge
 * stayed permanently empty. v4 instead reads the review data Judge.me itself
 * puts on the on-page Review Widget (.jdgm-rev-widg[data-average-rating]
 * [data-number-of-reviews], rendered by the theme app block) and draws the
 * stars locally: partial-fill overlay for the average, "N reviews" link that
 * scrolls to the widget. Zero reviews (or no widget) = nothing shows.
 */
(function () {
  var POLL_INTERVAL_MS = 500;
  var POLL_MAX_CHECKS = 40; /* ~20s for the app-block widget to appear + hydrate */
  var STAR_COLOR = '#108474'; /* matches Judge.me widget star teal */
  var EMPTY_COLOR = '#d9d9d9';
  var done = false;

  function getWidgetData() {
    var w = document.querySelector('.jdgm-rev-widg');
    if (!w) return null;
    var avg = parseFloat(w.getAttribute('data-average-rating'));
    var count = parseInt(w.getAttribute('data-number-of-reviews'), 10);
    if (isNaN(avg) || isNaN(count)) return null;
    return { widget: w, avg: avg, count: count };
  }

  function buildStarRow(avg) {
    var outer = document.createElement('span');
    outer.style.position = 'relative';
    outer.style.display = 'inline-block';
    outer.style.fontSize = '17px';
    outer.style.lineHeight = '1';
    outer.style.letterSpacing = '2px';

    var base = document.createElement('span');
    base.textContent = '★★★★★';
    base.style.color = EMPTY_COLOR;

    var fill = document.createElement('span');
    fill.textContent = '★★★★★';
    fill.style.color = STAR_COLOR;
    fill.style.position = 'absolute';
    fill.style.top = '0';
    fill.style.left = '0';
    fill.style.overflow = 'hidden';
    fill.style.whiteSpace = 'nowrap';
    fill.style.width = Math.max(0, Math.min(100, (avg / 5) * 100)) + '%';

    outer.appendChild(base);
    outer.appendChild(fill);
    return outer;
  }

  function scrollToWidget(widget) {
    try { widget.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    catch (e) { widget.scrollIntoView(); }
  }

  function inject(data) {
    if (document.querySelector('[data-fw-jdgm-badge="true"]')) return;
    var atcButtons = document.querySelectorAll('[data-pf-type="ProductATC2"]');
    if (!atcButtons.length) return;
    var block = atcButtons[atcButtons.length - 1].closest('[data-pf-type="Block"]');
    if (!block || !block.parentNode) return;

    var wrap = document.createElement('div');
    wrap.setAttribute('data-fw-jdgm-badge', 'true');
    wrap.style.margin = '10px 0 4px';
    wrap.style.display = 'flex';
    wrap.style.alignItems = 'center';
    wrap.style.gap = '8px';
    wrap.style.flexWrap = 'wrap';
    wrap.style.cursor = 'pointer';
    wrap.setAttribute('role', 'link');
    wrap.setAttribute('aria-label', data.avg.toFixed(1) + ' out of 5 stars, ' + data.count + ' review' + (data.count === 1 ? '' : 's'));

    wrap.appendChild(buildStarRow(data.avg));

    var label = document.createElement('span');
    label.textContent = data.avg.toFixed(1) + ' (' + data.count + ' review' + (data.count === 1 ? '' : 's') + ')';
    label.style.color = '#3897CD';
    label.style.fontSize = '13px';
    label.style.textDecoration = 'underline';
    wrap.appendChild(label);

    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      var tabBtn = document.querySelector('button[data-fw-review-tab]');
      if (!tabBtn) {
        var headers = document.querySelectorAll('[data-pf-type="TabHeader"]');
        for (var i = 0; i < headers.length; i++) {
          if (/review/i.test(headers[i].textContent || '')) { tabBtn = headers[i]; break; }
        }
      }
      if (tabBtn) {
        tabBtn.click();
        setTimeout(function () { scrollToWidget(data.widget); }, 150);
      } else {
        scrollToWidget(data.widget);
      }
    });

    block.parentNode.insertBefore(wrap, block.nextSibling);
  }

  var checks = 0;
  function poll() {
    if (done) return;
    checks++;
    var data = getWidgetData();
    if (data && data.count > 0) {
      done = true;
      inject(data);
      return;
    }
    if (checks < POLL_MAX_CHECKS) setTimeout(poll, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(poll, POLL_INTERVAL_MS); });
  } else {
    setTimeout(poll, POLL_INTERVAL_MS);
  }
})();

